import createValidator from 'typecheck.macro';
import { makeExperimentWithData } from '../../common/ExperimentContext/types';

export const CovidSpecialtyMessageExperiment = makeExperimentWithData(
  'TPL-InfoBox-SERP-Covid19',
  createValidator<
    | undefined
    | {
        desktopTitle: string;
        desktopBody: string;
        mobileTitle: string;
        mobileBody: string;
      }
  >(),
);
